const translations = {
  "en": {
    "Bearish": "Bearish",
    "Bullish": "Bullish",
    "Social Hype": "Social Hype"
  },
  "zh-tw": {
    "Bearish": "看跌",
    "Bullish": "看漲",
    "Social Hype": "社交熱潮"
  }
};

export default translations;
